const getters = {
  token: state => state.user.token,
  roles: state => state.user.roles,
  sidebar: state => state.app.sidebar,
  userMenus: state => state.user.userMenus,
  uploadAddr: state => state.app.uploadAddr,
  env: state => state.app.env,
  loginUser: state => state.user.loginUser,
  childrenMenus: state => state.menu.childrenMenus,
  reportsMenus: state => state.menu.reportsMenus,
  tabRoutes: state => state.tabs.tabRoutes,
  funcs: state => state.menu.funcs,
  cacheVueData: state => state.cachedata.cacheVueData,
  activeName: state => state.tabs.activeName,
  headerActiveName: state => state.tabs.headerActiveName,
  ispbrCenterClose: state => state.app.ispbrCenterClose,
  ispbrTenderFormClose: state => state.app.ispbrTenderFormClose,
  isauctionHallClose: state => state.app.isauctionHallClose,
  expertUserMenus: state => state.expert.userMenus,
  expertTableRoutes: state => state.expert.tabRoutes,
  expertLoginUser: state => state.expert.loginUser,
  expertActiveName: state => state.expert.activeName,
  isCollapse: state => state.app.isCollapse,
  pbrCenterInfo: state => state.app.pbrCenterInfo
}

export default getters
